// import React, { useEffect, useRef } from "react";
// import styled, { ThemeProvider } from "styled-components";
// import { DarkTheme } from "./Themes";
// import { motion } from "framer-motion";

// import LogoComponent from "../subComponents/LogoComponent";
// import SocialIcons from "../subComponents/SocialIcons";
// import PowerButton from "../subComponents/PowerButton";

// import { Work } from "../data/WorkData";
// import Card from "../subComponents/Card";
// import { YinYang } from "./AllSvgs";
// import BigTitlte from "../subComponents/BigTitlte";

// const Box = styled.div`
//   background-color: ${(props) => props.theme.body};

//   height: 400vh;
//   position: relative;
//   display: flex;
//   align-items: center;
// `;

// const Main = styled(motion.ul)`
//   position: fixed;
//   top: 12rem;
//   left: calc(10rem + 15vw);
//   height: 40vh;
//   display: flex;

//   color: white;
// `;
// const Rotate = styled.span`
//   display: block;
//   position: fixed;
//   right: 1rem;
//   bottom: 1rem;
//   width: 80px;
//   height: 80px;
//   z-index: 1;
// `;

// // Framer-motion Configuration
// const container = {
//   hidden: { opacity: 0 },
//   show: {
//     opacity: 1,

//     transition: {
//       staggerChildren: 0.5,
//       duration: 0.5,
//     },
//   },
// };

// const WorkPage = () => {
//   const ref = useRef(null);
//   const yinyang = useRef(null);

//   useEffect(() => {
//     let element = ref.current;
//     if (element && yinyang.current) {
//       const rotate = () => {
//         element.style.transform = `translateX(${-window.pageYOffset}px)`;
//         try{
//           return (yinyang.current.style.transform =
//             "rotate(" + -window.pageYOffset + "deg)");
//         }
//         catch(e){
//           return
//         }
//       };
//       window.addEventListener("scroll", rotate);
//       return () => {
//         window.removeEventListener("scroll", rotate);
//       };
//     }

//   }, []);

//   return (
//     <ThemeProvider theme={DarkTheme}>
//       <Box>
//         <LogoComponent theme="dark" />
//         <SocialIcons theme="dark" />
//         <PowerButton />

//         <Main ref={ref} variants={container} initial="hidden" animate="show">
//           {Work.map((d) => (
//             <Card key={d.id} data={d} />
//           ))}
//         </Main>
//         <Rotate ref={yinyang}>
//           <YinYang width={80} height={80} fill={DarkTheme.text} />
//         </Rotate>

//         <BigTitlte text="WORK" top="10%" right="20%" />
//         <BigTitlte text="scroll" top="75%" right="10%" />
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default WorkPage;


import React, { useEffect, useRef } from "react";
import styled, { ThemeProvider } from "styled-components";
import { DarkTheme } from "./Themes";
import { motion } from "framer-motion";

import LogoComponent from "../subComponents/LogoComponent";
import SocialIcons from "../subComponents/SocialIcons";
import PowerButton from "../subComponents/PowerButton";

import { Work } from "../data/WorkData";
import Card from "../subComponents/Card";
import { YinYang } from "./AllSvgs";
import BigTitlte from "../subComponents/BigTitlte";

const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  overflow: hidden;
`;

const Main = styled(motion.ul)`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  display: flex;
  width: 100vw;
  align-items: center;
  padding: 0 8rem;

  overflow-x: auto;
  overflow-y: hidden;
  
  /* Change cursor to indicate it's draggable */
  cursor: grab;
  
  /* Prevent text selection while dragging */
  user-select: none; 

  &::-webkit-scrollbar {
    display: none;
  }
  
  &::after {
    content: "";
    display: block;
    min-width: 8rem;
    height: 100%;
  }
`;

const Rotate = styled.span`
  display: block;
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  width: 80px;
  height: 80px;
  z-index: 1;
`;

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.5,
      duration: 0.5,
    },
  },
};

const WorkPage = () => {
  const ref = useRef(null);
  const yinyang = useRef(null);

  // --- DRAG LOGIC REFS ---
  const isDown = useRef(false); // Is the mouse button pressed?
  const startX = useRef(0);     // Where did the click start?
  const scrollLeft = useRef(0); // Initial scroll position on click

  // 1. Handle Rotation on Scroll (Native + Drag)
  useEffect(() => {
    const element = ref.current;
    const rotate = () => {
      if (element && yinyang.current) {
        yinyang.current.style.transform = `rotate(${-element.scrollLeft}deg)`;
      }
    };

    if (element) {
      element.addEventListener("scroll", rotate);
      return () => element.removeEventListener("scroll", rotate);
    }
  }, []);

  // 2. Mouse Down: Start Dragging
  const handleMouseDown = (e) => {
    const slider = ref.current;
    isDown.current = true;
    slider.style.cursor = "grabbing"; // Visual feedback
    
    // Get initial mouse position and current scroll
    startX.current = e.pageX - slider.offsetLeft;
    scrollLeft.current = slider.scrollLeft;
  };

  // 3. Mouse Leave/Up: Stop Dragging
  const handleMouseUpOrLeave = () => {
    isDown.current = false;
    if (ref.current) {
        ref.current.style.cursor = "grab";
    }
  };

  // 4. Mouse Move: Perform Scroll
  const handleMouseMove = (e) => {
    if (!isDown.current) return;
    
    e.preventDefault(); // Stop weird browser defaults
    const slider = ref.current;
    
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX.current) * 2; // * 2 determines drag speed
    
    slider.scrollLeft = scrollLeft.current - walk;
  };

  return (
    <ThemeProvider theme={DarkTheme}>
      <Box>
        <LogoComponent theme="dark" />
        <SocialIcons theme="dark" />
        <PowerButton />

        <Main
          ref={ref}
          variants={container}
          initial="hidden"
          animate="show"
          // Attach Drag Events Here
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseUpOrLeave}
          onMouseUp={handleMouseUpOrLeave}
          onMouseMove={handleMouseMove}
        >
          {Work.map((d) => (
            <Card key={d.id} data={d} />
          ))}
        </Main>
        
        <Rotate ref={yinyang}>
          <YinYang width={80} height={80} fill={DarkTheme.text} />
        </Rotate>

        <BigTitlte text="WORK" top="10%" right="20%" />
        <BigTitlte text="SWIPE" top="75%" right="10%" />
      </Box>
    </ThemeProvider>
  );
};

export default WorkPage;